import React, { useState } from "react"
import useQuery from "@/hooks/useQuery"

import { Accordion, AccordionDetails, AccordionSummary, Chip, Grid, Typography } from "@material-ui/core"
import { ExpandMore as ExpandMoreIcon } from "@material-ui/icons"

import SetupTrackableLinkSteps from "@/pages/Admin/TrackableLinks/TrackableLinkMetrics/SetupTrackableLinkAccordion/SetupTrackableLinkSteps"
import { Trackablelink } from "@/protocols/trackableLinks"

import { BlueSettingsClockIcon } from "@/assets/icons"
import useStyles from "@/pages/Admin/TrackableLinks/TrackableLinkMetrics/SetupTrackableLinkAccordion/styles"

type SetupTrackableLinkAccordionProps = {
	trackableLinkToSetup: Trackablelink
}

const SetupTrackableLinkAccordion: React.FC<SetupTrackableLinkAccordionProps> = (props) => {
	const { trackableLinkToSetup } = props
	const classes = useStyles()
	const queryParams = useQuery()

	const hasUserCameFromCreateLinkPage = queryParams.get("from") === "create"

	const [expandedAccordion, setExpandedAccordion] = useState(hasUserCameFromCreateLinkPage)

	const handleExpandedAccordionChange = () => {
		setExpandedAccordion(!expandedAccordion)
	}

	return (
		<Accordion
			expanded={expandedAccordion}
			className={classes.accordion}
			onChange={handleExpandedAccordionChange}
		>
			<AccordionSummary
				expandIcon={<ExpandMoreIcon fontSize="small" />}
				IconButtonProps={
					{
						classes: {
							root: classes.accordionSummaryIcon
						}
					}
				}
			>
				<Chip
					icon={
						<BlueSettingsClockIcon className={classes.accordionSummaryChipIcon} />
					}
					label="Configuração do seu link no Meta Ads"
					size="small"
					className={classes.accordionSummaryChip}
				/>
			</AccordionSummary>
			<AccordionDetails>
				<Grid container direction="column" spacing={4}>
					<Grid item>
						<Grid container direction="column" spacing={1}>
							<Grid item>
								<Typography variant="h5" className={classes.accordionDetailsTitle}>
									Instruções para a configuração do seu link
								</Typography>
							</Grid>
							<Grid item>
								<Typography variant="body1">
									Basta seguir o passo a passo abaixo para finalizar a configuração do seu link rastreável. Vamos nessa! 🚀
								</Typography>
							</Grid>
						</Grid>
					</Grid>

					<Grid item>
						<SetupTrackableLinkSteps trackableLinkToSetup={trackableLinkToSetup} />
					</Grid>
				</Grid>
			</AccordionDetails>
		</Accordion>
	)
}

export default SetupTrackableLinkAccordion
